import { Component } from '@angular/core';

@Component({
  selector: 'ng-run-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {}
